import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

/**
 * Calculate the radial progress length and set the stroke length
 * based on 250(total circle circumference) in total divisible by 5
 *
 * @param {Number} number dividend
 * @param {Number} total divisor/total
 * @returns {Number} progress stroke length
 */
const _progressBar = function (number, total) {
  if (!number || !total) {
    return 0;
  }

  return Math.ceil(((number / total) * 250) / 5) * 5;
};

const ProgressRadial = ({ count, total, extraClasses }) => {
  const classes = classNames('progress-radial', extraClasses);

  return (
    <svg className={classes} viewBox="0 0 100 100">
      <circle cx="50" cy="50" r="40" fill="white" />
      <circle cx="50" cy="50" r="40" className="progress-radial-stroke" />
      <circle cx="50" cy="50" r="40" className="progress-radial-bar" strokeDashoffset={_progressBar(count, total)} />
      <text x="50%" y="50%" className="progress-radial-text" dy="0.3em">
        {count}
      </text>
    </svg>
  );
};

ProgressRadial.propTypes = {
  count: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  extraClasses: PropTypes.string,
};

export default ProgressRadial;
